"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var Lang_js_1 = require("../Lang.js");
var IntentURL_1 = require("./IntentURL");
var LastTransaction_1 = __importDefault(require("./LastTransaction"));
var bull = (react_1.default.createElement(material_1.Box, { component: "span", sx: { display: 'inline-block', mx: '2px', transform: 'scale(0.8)' } }, "\u2022"));
var img_path = document.getElementById('donation-form') ? document.getElementById('donation-form').getAttribute('img_path') : '';
var SavedPaymentMethods = function (props) {
    var _a;
    var _b = (0, react_1.useState)(null), errrorMessageSC = _b[0], setErrrorMessageSC = _b[1];
    var _c = (0, react_1.useState)(false), isFormProcessingSC = _c[0], setFormProcessingSC = _c[1];
    var _d = (0, react_1.useState)(null), paymentMethodId = _d[0], setPaymentMethodId = _d[1];
    var form = document.getElementById('donation-form');
    var imperative_verb = form.getAttribute('imperative_verb').includes('[imperative verb]') ? "Give" : (_a = form.getAttribute('imperative_verb')) !== null && _a !== void 0 ? _a : "Give";
    var handleDelete = function (payment_method_id) { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed, response, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    event.preventDefault();
                    confirmed = window.confirm((0, Lang_js_1.__)("Are you sure you want to delete this payment method?"));
                    if (!confirmed) {
                        return [2 /*return*/]; // User cancelled
                    }
                    console.log("Deleting " + payment_method_id);
                    setFormProcessingSC(true);
                    setErrrorMessageSC(null);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axios_1.default.get('/api/donations/deletePaymentMethod?payment_method_id=' + payment_method_id)];
                case 2:
                    response = _d.sent();
                    if (response.data.deleted) {
                        (_a = document.getElementById(payment_method_id)) === null || _a === void 0 ? void 0 : _a.remove();
                        if (response.data.payment_methods.length === 0) {
                            (_b = document.getElementById('saved_payments_area')) === null || _b === void 0 ? void 0 : _b.remove();
                        }
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    console.warn(error_1);
                    setErrrorMessageSC((_c = error_1.message) !== null && _c !== void 0 ? _c : (0, Lang_js_1.__)("Unable to delete payment method"));
                    return [3 /*break*/, 5];
                case 4:
                    setFormProcessingSC(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }; };
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var originAttr, originParam, return_url, payment_method_id, form_1, amount, response, separator, error_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    event.preventDefault();
                    setFormProcessingSC(true);
                    setErrrorMessageSC(null);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    originAttr = ((_a = document.getElementById('donation-form')) === null || _a === void 0 ? void 0 : _a.getAttribute('origin')) || '';
                    originParam = originAttr ? '?origin=' + encodeURIComponent(originAttr) : '';
                    return_url = 'https://' + window.location.hostname + '/app/donate/complete' + originParam;
                    payment_method_id = paymentMethodId;
                    form_1 = document.getElementById('donation-form');
                    amount = parseInt((_b = form_1.getAttribute('amount')) !== null && _b !== void 0 ? _b : "100");
                    return [4 /*yield*/, axios_1.default.get((0, IntentURL_1.SavedIntentURL)(amount, payment_method_id, return_url))];
                case 2:
                    response = _e.sent();
                    if (response.data.status === 'success') {
                        separator = return_url.includes('?') ? '&' : '?';
                        window.location.href = "".concat(return_url).concat(separator, "payment_intent=").concat(response.data.client_secret.substring(0, 27), "&payment_intent_client_secret=").concat(response.data.client_secret, "&redirect_status=succeeded");
                    }
                    else {
                        console.warn(response.data);
                        setErrrorMessageSC((_c = response.data.message) !== null && _c !== void 0 ? _c : (0, Lang_js_1.__)("Unable to process payment"));
                        setFormProcessingSC(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _e.sent();
                    console.warn(error_2);
                    setErrrorMessageSC((_d = error_2.message) !== null && _d !== void 0 ? _d : "Unable to process payment");
                    setFormProcessingSC(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { id: "saved_payments_area" }, (props.payment_methods.length > 0) &&
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.Card, { elevation: 0 },
                react_1.default.createElement(material_1.CardHeader, { avatar: react_1.default.createElement(icons_material_1.GppGood, { color: "success" }), title: (0, Lang_js_1.__)("Saved payment methods available"), sx: { py: 1, px: 2 } }),
                react_1.default.createElement(material_1.CardContent, { sx: { px: 2, py: 0, '&:last-child': { pb: 1 } } },
                    react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement(material_1.Typography, { variant: "h6" }, (0, Lang_js_1.__)('Choose a saved payment method:')),
                        react_1.default.createElement(material_1.RadioGroup, { name: "saved_payment_method_id" },
                            react_1.default.createElement(material_1.List, { sx: { fontFamily: "monospace", width: "100%", py: 0 } }, props.payment_methods.map(function (payment_method) { return (react_1.default.createElement(material_1.FormControlLabel, { disabled: isFormProcessingSC, id: payment_method.id, sx: { bgColor: "LightGrey", border: 1, borderRadius: '16px', borderColor: 'grey', m: 1 }, value: payment_method.id, control: react_1.default.createElement(material_1.Radio, { onClick: function () { setPaymentMethodId(payment_method.id); setErrrorMessageSC(null); } }), key: payment_method.id, label: react_1.default.createElement(material_1.ListItem, { alignItems: "flex-start", key: payment_method.id },
                                    react_1.default.createElement(material_1.ListItemButton, null,
                                        react_1.default.createElement(material_1.ListItemIcon, null,
                                            react_1.default.createElement("img", { src: img_path + "/" + payment_method.card.brand + ".png", onError: function (_a) {
                                                    var currentTarget = _a.currentTarget;
                                                    onerror = null;
                                                    currentTarget.src = img_path + "/generic.png";
                                                }, alt: payment_method.card.brand, style: { maxWidth: '64px', marginLeft: "-2em" } })),
                                        react_1.default.createElement(material_1.ListItemText, { secondary: react_1.default.createElement(material_1.Typography, { fontSize: "small", textAlign: "right" },
                                                (0, Lang_js_1.__)('exp.'),
                                                " ",
                                                payment_method.card.exp_month,
                                                "/",
                                                payment_method.card.exp_year) },
                                            react_1.default.createElement("span", { className: "d-sm-none d-md-block" },
                                                bull,
                                                bull,
                                                bull,
                                                bull,
                                                " ",
                                                bull,
                                                bull,
                                                bull,
                                                bull,
                                                " ",
                                                bull,
                                                bull,
                                                bull,
                                                bull),
                                            " ",
                                            payment_method.card.last4)),
                                    react_1.default.createElement(material_1.ListItemSecondaryAction, { sx: { ml: 4 }, children: react_1.default.createElement(material_1.IconButton, { "aria-label": "delete", onClick: handleDelete(payment_method.id) },
                                            react_1.default.createElement(icons_material_1.DeleteForever, { sx: { color: "red" } })) })) })); }))),
                        errrorMessageSC && react_1.default.createElement(material_1.Alert, { severity: "error" }, errrorMessageSC),
                        react_1.default.createElement(material_1.Button, { type: "submit", disabled: isFormProcessingSC || !paymentMethodId, variant: "contained", fullWidth: true, size: "large", sx: { p: 1, mt: 1, mb: 1, maxWidth: 480 } }, (0, Lang_js_1.__)(imperative_verb))),
                    (form === null || form === void 0 ? void 0 : form.getAttribute('origin')) !== 'subscription-cart' &&
                        react_1.default.createElement(LastTransaction_1.default, { displayType: "info" }))),
            react_1.default.createElement(material_1.Modal, { open: isFormProcessingSC, onClose: function () { return; }, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description" },
                react_1.default.createElement(material_1.Box, { display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center", bgcolor: "white" },
                    react_1.default.createElement("div", { id: "modal-modal-title", style: { display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement(material_1.CircularProgress, null)),
                    react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'center', minHeight: '3rem', marginLeft: '1rem' } },
                        react_1.default.createElement(material_1.Typography, { id: "modal-modal-description", sx: { mt: 2 } }, (0, Lang_js_1.__)("Please wait..."))))),
            react_1.default.createElement(material_1.Divider, { variant: "middle", sx: { my: 1 } }),
            react_1.default.createElement(material_1.Typography, { align: "center", variant: "h6", sx: { mb: 1, mt: 1 } }, (0, Lang_js_1.__)('or enter new payment details below')),
            react_1.default.createElement(material_1.Divider, { variant: "middle", sx: { my: 1 } }))));
};
exports.default = SavedPaymentMethods;
